import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

/**
 * Logs missing translation keys and falls back to the key itself, so a gap shows up as
 * the raw key in the UI instead of an empty string.
 */
export class AppMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    console.error(`Missing Lang! Key: ${params.key} Lang: ${params.translateService.currentLang}`);
    return params.key;
  }
}
